import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Col, message, Modal, notification, Row } from "antd";
import { SubmitNomineeApi } from "../../../Services/EmployeeOnboarding";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { getNomineeColumnsConfig } from "./Component/ComlumnConfig";
import axios from "axios";
import CustomEditableCard from "./Component/IdentityTable";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const defaultRelations = [{ label: 1 }];

export default function Nominee({ current, setCurrent }) {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });

  const [api, contextHolder] = notification.useNotification();
  const [isError, setIsError] = useState(false);
  const [isFinalModal, setIsFinalModal] = useState(false);
  const [loading, setLoading] = useState({ final: false, submit: false });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [place, setPlace] = useState("");
  const { responseData, id } = useOutletContext();
  const type = localStorage.getItem("userType");
  const [tncPdfUrl, setTncPdfUrl] = useState(null);
  const [tncLoading, setTncLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };

  const { dropDowns } = useOutletContext();
  const formatLabel = (str) => {
    if (!str || typeof str !== "string") return str;
    if (str.toLowerCase() === "phd") return "PhD";
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const relationshipdrop =
    (dropDowns &&
      dropDowns.RELATIONSHIP?.map((item) => {
        const val = typeof item === "object" ? item.value : item;
        return {
          label: formatLabel(val),
          value: val,
        };
      })) ||
    [];

  const navigate = useNavigate(null);
  const [output, setOutput] = useState(null);
  const [tableData, setTableData] = useState(defaultRelations);
  const handleAddRow = () => {
    setTableData((prev) => [
      ...prev,
      {
        label: generateSimpleId(),
      },
    ]);
  };
  const handleRemoveRow = (labelToRemove) => {
    setTableData((prev) => prev.filter((row) => row.label !== labelToRemove));
  };
  const handleChangeValue = (value, field, relation) => {
    if (field === "relationship" && (value === "son" || value === "daughter")) {
      const currentChildrenCount = Object.entries(output || {}).filter(
        ([key, nominee]) =>
          key !== relation &&
          (nominee.relationship === "son" || nominee.relationship === "daughter")
      ).length;

      if (currentChildrenCount >= 3) {
        const prevValue = output?.[relation]?.[field] || null;
        setValue(`${field}_${relation}`, prevValue);
        return api.error({
          message: "Maximum 3 children (Son/Daughter) are allowed as nominees",
          placement: "top",
        });
      }
    }
    setOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };
  const nomineecolumnsConfig = getNomineeColumnsConfig(
    handleChangeValue,
    relationshipdrop,
  );

  const counter = useRef(0);

  function generateSimpleId() {
    return (
      "id-" +
      (counter.current++).toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 5)
    );
  }
  useEffect(() => {
    let blobUrl;

    async function preloadTncPdf() {
      try {
        setTncLoading(true);

        const res = await axios.get(
          "/api/employee-connect/employee/annexure-2",
        );

        console.log(res);
        setTncPdfUrl(res?.data?.document);
      } catch (err) {
        console.error("Failed to preload T&C PDF", err);
      } finally {
        setTncLoading(false);
      }
    }

    preloadTncPdf();

    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, []);

  const onSubmit = async (val) => {
    if (!isAllFieldsValid()) {
      api.error({
        message: "Validation Error",
        description: "Please ensure all nominee details are filled and you have agreed to the declarations.",
        placement: "top",
      });
      return;
    }

    setLoading((prev) => ({
      ...prev,
      submit: true,
    }));

    let currentAgreed = isAgreed;
    if (!currentAgreed) {
      currentAgreed = await sendTermPdfFile();
      if (!currentAgreed) {
        setLoading((prev) => ({
          ...prev,
          submit: true, // Wait, if I set it to true it will stay disabled. Should be false.
          submit: false,
        }));
        return;
      }
    }

    if (!output) {
      setLoading((prev) => ({
        ...prev,
        submit: false,
      }));
      return api.error({
        message: "Please Fill Nominee Detail",
        placement: "top",
      });
    }

    const nomineeDetail = Object.values(output);

    try {
      const { data } = await SubmitNomineeApi(nomineeDetail);
      setLoading((prev) => ({
        ...prev,
        submit: false,
      }));
      console.log();
      if (data?.success) {
        if (currentAgreed) {
          if (responseData?.final_submit) {
            handleSubmitFinal();
          } else {
            setIsFinalModal(true);
          }
        } else {
          api.error({
            message: "Please Agree to the Terms and Conditions",
            placement: "top",
          });
        }
      } else {
        api.error({
          message: data?.message,
          placement: "top",
        });

        throw new Error(
          "Submission failed: " + (data?.message || "Unknown error"),
        );
      }
    } catch (error) {
      console.error("Error submitting details:", error);
    }
  };

  async function sendTermPdfFile() {
    try {
      if (!isChecked) {
        setIsError({
          message: "Please Check Terms And Condition",
        });
        return false;
      }
      if (!place) {
        setIsError({
          message: "Please enter place",
        });
        return false;
      }

      const formData = new FormData();
      formData.append("i_agree", isChecked);
      formData.append("place", place);

      const { data } = await axios.post(
        "/api/employees/employee-tnc",
        formData,
      );

      console.log(data);
      if (data?.success) {
        setIsOpen(false);
        localStorage.removeItem("pdfModalWasOpen");

        await getTermAgreed();
        api.success({
          message: data?.message,
          placement: "top",
        });
        return true;
      } else {
        api.error({
          message: data?.message || data?.error,
          placement: "top",
        });
        return false;
      }
    } catch (error) {
      console.error("Error sending PDF file:", error);
      return false;
    }
  }
  const getTermAgreed = async () => {
    const { data } = await axios.get("/api/employees/employee-tnc");
    console.log(data, "checcking data");
    setIsAgreed(data?.i_agree);
    if (data?.i_agree) {
      setIsChecked(true);
    }
    if (data?.place) {
      setPlace(data?.place);
    }
    return data?.i_agree;
  };

  const getNomineeDetail = async (responseData) => {
    const updated = {};
    const values = {};
    responseData?.nominees?.forEach((item, index) => {
      const rowLabel = index + 1;
      updated[rowLabel] = { ...item };
      // Populate individual fields for react-hook-form
      Object.entries(item).forEach(([key, val]) => {
        values[`${key}_${rowLabel}`] = val;
      });
    });
    setOutput(updated);
    reset(values);
  };

  const getEmployeeDetail = async () => {
    getNomineeDetail(responseData);
    getTermAgreed();
  };

  const isAllFieldsValid = () => {
    // Check Nominee Details (at least 1 and all fields filled)
    if (!output || Object.keys(output).length === 0) {
      return false;
    }
    for (const nominee of Object.values(output)) {
      if (!nominee.full_name || !nominee.relationship || !nominee.share_percentage || !nominee.dob || !nominee.aadhar_number) {
        return false;
      }
    }

    // Check Declaration
    if (!place || !isChecked) {
      return false;
    }

    return true;
  };

  const is_Final_submit =
    responseData?.final_submit?.nominees_meta?.final_submit;

  const shouldDisableFields = (sectionMeta) => {
    if (!sectionMeta) return false;

    const isFinalSubmit = sectionMeta.final_submit === true;
    const isApproved = sectionMeta.is_approved === true;

    if (isFinalSubmit && isApproved) {
      return true;
    } else {
      const hasReason =
        sectionMeta.reason && sectionMeta.reason.trim() !== "" ? true : false;
      if (isFinalSubmit && isApproved && hasReason) {
        return true;
      } else {
        return false;
      }
    }
  };

  const disabledNomnee = shouldDisableFields(
    responseData?.final_submit?.nominees_meta,
  );

  const handleSubmitFinal = async () => {
    setLoading((prev) => ({ ...prev, final: true }));

    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
      sections: ["nominees"],
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/offer-letter");
    } else {
      api.error({
        message: data?.error,
        placement: "top",
      });
    }
  };

  useEffect(() => {
    getEmployeeDetail();
  }, [reset, responseData]);

  const isFieldDisabled = (fieldName) => {
    if (type === "admin") return true;
    if (!disabledNomnee) return false;

    // Check if the field is flagged for correction
    const isFlagged = responseData?.flagged_fields?.some(
      (f) => f.id === fieldName,
    );
    return !isFlagged;
  };

  const hasFlaggedFields = responseData?.flagged_fields?.some(
    (f) =>
      f.id.startsWith("nominee.") ||
      f.id === "place" ||
      f.id === "i_agree" ||
      f.id === "nominees",
  );

  return (
    <>
      {contextHolder}
      <h3 className="color-heading mb-4">Nominee & Declarations</h3>

      <form className="h-full" onSubmit={handleSubmit(onSubmit)}>
        <div className=" border rounded-xl bg-white shadow-md">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(0)}
          >
            <h3 className="color-heading2"> Nominee Details</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 0 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 0 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <div className=" w-full mb-4">
                <CustomEditableCard
                  control={control}
                  errors={errors}
                  handleAddRow={handleAddRow}
                  handleRemoveRow={handleRemoveRow}
                  columnsConfig={nomineecolumnsConfig}
                  tableData={tableData}
                  setTableData={setTableData}
                  setOutput={setOutput}
                  output={output}
                  allDisabled={disabledNomnee}
                  flaggedFields={responseData?.flagged_fields}
                  isAddDisabled={false}
                  rowTitle={(record, index) => `Nominee #${index + 1}`}
                />
              </div>
            </div>
          )}
        </div>

        <div className=" border rounded-xl bg-white mt-5 shadow-md">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(1)}
          >
            <h3 className="color-heading2">Declaration (T & C)</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 1 ? "rotate-180" : ""
                }`}
            />
          </div>

          {activeIndex === 1 && (
            <>
              <div
                className={`transition-all duration-300 overflow-hidden p-4`}
              >
                {tncPdfUrl ? (
                  <iframe
                    src={tncPdfUrl}
                    title="T&C"
                    width="100%"
                    height="800px"
                    style={{
                      border: "none",
                      backgroundColor: "#fff",
                      display: "block",
                    }}
                  />
                ) : (
                  <p>Loading document...</p>
                )}

                {true && (
                  <div className=" justify-between items-center">
                    <div className="mt-3 mb-2 flex justify-start flex-wrap">
                      <label className="block text-lg font-medium text-gray-700 mb-1">
                        Place:
                        <span className="text-red-500">*</span>
                      </label>

                      <input
                        type="text"
                        placeholder="Enter place (e.g. Delhi)"
                        value={place}
                        disabled={isFieldDisabled("place")}
                        onChange={(e) => setPlace(e.target.value)}
                        className="w-fit border ml-1 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
                      />
                    </div>
                    {!place && (
                      <div className="text-red-500 text-left">
                        {" "}
                        {isError && "Please enter place"}
                      </div>
                    )}

                    <label className="flex items-center justify-start ml-1 pt-3 text-sm text-gray-700">
                      <input
                        type="checkbox"
                        className="mr-2  mt-2 self-start scale-150"
                        checked={isChecked}
                        disabled={isFieldDisabled("i_agree")}
                        onChange={handleCheckboxChange}
                      />
                      <div className="self-start">
                        <div className="text-lg">
                          I have read and agree to the company policies and
                          terms & conditions mentioned above. I declare that all
                          information provided is accurate and complete.
                        </div>
                        {!isChecked && (
                          <div className="text-red-500 text-left">
                            {" "}
                            {isError && isError?.message}
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <Row className="step-buttons-box justify-end pt-3 px-2" style={{ borderTop: '1px solid #e5e7eb' }}>
          <button
            type="button"
            className="my-2 step-button mr-2 back-button"
            style={{ backgroundColor: "#FFFFFF", color: "#A4A4A4", border: "1px solid #A4A4A4" }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Back
          </button>
          <button
            disabled={
              (is_Final_submit && !hasFlaggedFields) ||
              loading?.submit
            }
            className="my-2 text-white step-button"
            type="submit"
          >
            {loading?.submit ? "Submitting..." : "Submit"}
          </button>
        </Row>
      </form>

      <Modal
        title="Are you sure you want to submit your data for HR review?"
        open={isFinalModal}
        onCancel={() => setIsFinalModal(false)}
        width="600px"
        footer={[
          <Button key="cancel" onClick={() => setIsFinalModal(false)}>
            Cancel
          </Button>,
          <Button
            type="success"
            className="bg-green-500 text-white"
            onClick={handleSubmitFinal}
            loading={loading?.final}
          >
            Submit
          </Button>,
        ]}
      />
    </>
  );
}
